import { GetVendorBranch_vendor_getVendorBranchByID_vendorBranch_vendor } from '../graphql/athena/types/GetVendorBranch';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';

interface VendorInfoItemProps {
  title: string;
  value?: string;
  expired?: boolean;
}

const VendorInfoItem = ({ title, value, expired }: VendorInfoItemProps) => {
  if (!value) return null;
  return (
    <VerticalLayout className="pr-7">
      <span className="gray4">{title}</span>
      <span>
        <span>{value}</span>
        {expired && (
          <span data-testid="expired-tag" className="red4 pl-2">
            Expired
          </span>
        )}
      </span>
    </VerticalLayout>
  );
};

const isExpired = (date?: string | null) => {
  if (!date) return false;
  return new Date(date).valueOf() < Date.now();
};

const toDate = (date?: Date | string | null) => {
  if (!date) return undefined;
  const dateTime = new Date(date);
  return `${dateTime.getMonth() + 1}/${dateTime.getDate() + 1}/${dateTime.getFullYear()}`;
};

interface VendorInfoProps {
  vendor?: GetVendorBranch_vendor_getVendorBranchByID_vendorBranch_vendor;
}

const VendorInfo = ({ vendor }: VendorInfoProps) => {
  if (!vendor) {
    return null;
  }
  return (
    <HorizontalLayout>
      <VendorInfoItem title="Joined On" value={toDate(vendor.createdAt)} />
      <VendorInfoItem title="Total Branches" value={vendor.branchIds?.length?.toString()} />
      <VendorInfoItem
        title="General Liability"
        value={toDate(vendor.compliance?.generalLiabilityInsuranceExpires)}
        expired={isExpired(vendor.compliance?.generalLiabilityInsuranceExpires)}
      />
      <VendorInfoItem
        title="Auto Insurance"
        value={toDate(vendor.compliance?.autoInsuranceExpires)}
        expired={isExpired(vendor.compliance?.autoInsuranceExpires)}
      />
      {!vendor.compliance?.workersCompExempt && (
        <VendorInfoItem
          title="Workers Comp"
          value={toDate(vendor.compliance?.workersCompExpires)}
          expired={isExpired(vendor.compliance?.workersCompExpires)}
        />
      )}
    </HorizontalLayout>
  );
};

export default VendorInfo;
